import React, { Component } from 'react';
import { Rect, Group } from 'react-konva';

export class PassingIntervalsComponentCanvas extends Component {
    render() {
        const { geometry, component, isSelected, dimentionsRatio, draggable } = this.props;

        const geometryWidthRatio = geometry.width / 300.0;
        const geometryHeightRatio = geometry.height / 840.0;

        const smallHeight = 60 * geometryHeightRatio * dimentionsRatio;
        const mediumHeight = 80 * geometryHeightRatio * dimentionsRatio;
        const bigHeight = 100 * geometryHeightRatio * dimentionsRatio;
        const smallWidth = 50 * geometryWidthRatio * dimentionsRatio;
        const bigWidth = 200 * geometryWidthRatio * dimentionsRatio;
        const mediumWidth = bigWidth * 0.475;

        const elementsFirstPosX = geometry.drawPositionX + 20 * geometryWidthRatio * dimentionsRatio;
        const elementsSecondPosX = elementsFirstPosX + smallWidth + 10 * geometryWidthRatio * dimentionsRatio;

        let elementsY = geometry.drawPositionY + 50 * geometryHeightRatio * dimentionsRatio;

        const componentSecundaryColor = "#EBF5FA";
        const geometryWidth = geometry.width * dimentionsRatio;
        const geometryHeight = geometry.height * dimentionsRatio;

        const elements = [];

        // Helper to push Rects with common props and keys
        const rectCommonProps = { strokeWidth: 1, stroke: "black", fill: componentSecundaryColor };
        const pushRect = (x, y, width, height) => {
            elements.push(
                <Rect
                    key={elements.length}
                    x={x}
                    y={y}
                    width={width}
                    height={height}
                    {...rectCommonProps} />
            );
        };

        // Component Name
        pushRect(elementsSecondPosX, elementsY, bigWidth, bigHeight);
        elementsY += bigHeight + 30 * geometryHeightRatio * dimentionsRatio;

        // Main Day Type
        pushRect(elementsSecondPosX, elementsY, mediumWidth, bigHeight);
        elementsY += bigHeight + 30 * geometryHeightRatio * dimentionsRatio;

        // Main Plannings and Secondary Day Types
        for (let i = 0; i < 2; i++) {
            const x = elementsSecondPosX + (i * bigWidth * 0.05 + i * mediumWidth);
            pushRect(x, elementsY, mediumWidth, mediumHeight);
        }
        elementsY += mediumHeight + 30 * geometryHeightRatio * dimentionsRatio;

        // First Trips
        pushRect(elementsFirstPosX, elementsY, smallWidth, mediumHeight);
        pushRect(elementsSecondPosX, elementsY, mediumWidth, mediumHeight);
        pushRect(elementsSecondPosX + bigWidth * 0.05 + mediumWidth, elementsY, mediumWidth / 2, mediumHeight);
        pushRect(elementsSecondPosX + bigWidth * 0.05 + mediumWidth * 1.5, elementsY, mediumWidth / 2, mediumHeight);
        elementsY += mediumHeight + 30 * geometryHeightRatio * dimentionsRatio;

        // Intervals
        for (let i = 0; i < 2; i++) {
            pushRect(elementsFirstPosX, elementsY, smallWidth, smallHeight);
            elementsY += smallHeight + 30 * geometryHeightRatio * dimentionsRatio;
        }

        // Last Trips
        pushRect(elementsFirstPosX, elementsY, smallWidth, mediumHeight);
        pushRect(elementsSecondPosX, elementsY, mediumWidth, mediumHeight);
        pushRect(elementsSecondPosX + bigWidth * 0.05 + mediumWidth, elementsY, mediumWidth / 2, mediumHeight);
        pushRect(elementsSecondPosX + bigWidth * 0.05 + mediumWidth * 1.5, elementsY, mediumWidth / 2, mediumHeight);

        return (
            <Group
                offsetX={geometry.offsetX}
                offsetY={geometry.offsetY}
                draggable={draggable}
                onDragEnd={this.props.onDragEnd}
                onClick={this.props.onComponentClick ? () => this.props.onComponentClick(component.internalId) : null} >
                <Rect x={geometry.drawPositionX}
                    y={geometry.drawPositionY}
                    width={geometryWidth}
                    height={geometryHeight}
                    strokeWidth={isSelected ? 3 : 1}
                    stroke={isSelected ? "#6699ff" : "black"}
                    fill={component.color} />

                <Group>
                    {elements}
                </Group>
            </Group>
        );
    }
}
